// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.genericResponse.StringResponse
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { BaseIssue } from "abweb/dto/generated/genericResponse/BaseIssue";
import { BaseResponse } from "abweb/dto/genericResponse/BaseResponse";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class StringResponseBase extends BaseResponse {
  /** Do NOT invoke directly, instead use strongly typed createStringResponseBase factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadg.StringResponse";
  }
  initFromJson(json, deserializeContext) {
    this.initStringResponse(TSOGUtils.decodeObject(json.issue, BaseIssue, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "issue")), json.payload != null ? json.payload : null);
  }
  initStringResponse(issue, payload) {
    this.initBaseResponse(issue, payload);
  }
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    return retVal;
  }
}
//# sourceMappingURL=StringResponseBase.js.map
